export const SET_CURRENT_MODULE = 'TRADE-AGREEMENTS/SET_CURRENT_MODULE';

export const setCurrentModule = (payload) => {
  return {
    type: SET_CURRENT_MODULE,
    payload,
  };
};
